import React, { useState } from "react";
import PropTypes from "prop-types";
import "./style.scss";
import { MathUtils } from "../../utils";
const RangeSlider = ({
  defaultValue,
  min,
  max,
  step,
  lang,
  isSpecialFormat,
  callback = () => {}
}) => {
  const [selectedValue, setSelectedValue] = useState(defaultValue || min);

  const calculatePosition = val => {
    const newVal = Number(((val - min) * 100) / (max - min));
    return `calc(${newVal}% + (${8 - newVal * 0.15}px))`;
  };

  const handleCallback = () => callback(selectedValue);
  return (
    <div className="range-slider">
      <div className="range-value">
        {/*The unit with price is the default*/}
        <div
          className="value"
          style={{ left: calculatePosition(selectedValue) }}
        >{`${
          MathUtils.priceFormatSpecial(selectedValue,lang,isSpecialFormat)
        }`}</div>
      </div>
      <div className="range-input-container">
        <input
          className="range-input"
          type="range"
          min={min}
          max={max}
          step={step}
          value={selectedValue}
          onChange={event => setSelectedValue(event.target.value)}
          onMouseUp={handleCallback}
          onTouchEnd={handleCallback}
          onKeyUp={handleCallback}
        />
        <div className="track-stops">
          <div className="stop start" />
          <div className="track" />
          <div className="stop end" />
        </div>
      </div>
      <div className="min-max">
        <div className="min">{`${
         MathUtils.priceFormatSpecial(min,lang,isSpecialFormat)}`}</div>
        <div className="max">{`${
         MathUtils.priceFormatSpecial(max,lang,isSpecialFormat)
        }`}</div>
      </div>
    </div>
  );
};

RangeSlider.propTypes = {
  defaultValue: PropTypes.number,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  step: PropTypes.number,
  unit: PropTypes.string,
  callback: PropTypes.func
};

export default RangeSlider;
